import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { M63RichTextWithBackgroundFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { CSSProperties, FC } from 'react'
import s from './M63RichTextWithBackground.module.scss'

type M63RichTextWithBackgroundProps = M63RichTextWithBackgroundFragment

const M63RichTextWithBackground: FC<M63RichTextWithBackgroundProps> = ({
  backgroundImage,
  richText,
  widthInVw,
  padding,
  mobilePadding,
  fontColor,
  link,
}) => {
  return (
    <div className={clsx(s.root, 'container')}>
      <Link link={link}>
        <div
          className={s.media}
          style={
            {
              '--bg-image': `url(${backgroundImage.url})`,
              '--padding': `${padding ?? 0}rem`,
              '--mobile-padding': `${mobilePadding ?? 0}rem`,
              '--width': `${widthInVw ?? 0}vw`,
              '--font-color': fontColor,
            } as CSSProperties
          }
        >
          <TrustedHtml className={s.richText} html={richText} />
        </div>
      </Link>
    </div>
  )
}

export default M63RichTextWithBackground
